export default __webpack_public_path__ + "static/media/ic_check_circle.d75d5d33.svg";